import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';

  .RegistrationForm {
    width: 100%;
    padding: 30px 0;
    text-align: center;
    display: flex;
    flex-direction: column;

    .DefaultButton {
      align-self: center;
    }
    .regForm__submit-button {
      width: 100%;
      line-height: 2.4rem;
    }
    .regForm__submit-button span{
      text-align: center;
    }
    span {
      display: block;
      text-align: left;
    }
    strong {
      display: block;
      text-align: left;
    }

    #telegramAuthWrapper {
      margin-top: 25px;
    }

    .disclamer {
      &__text {
        text-align: center;
        font-size: 15px;
        line-height: 20px;
        margin-bottom: 20px;
        &--noMG {
          margin-bottom: 0;
        }
      }
    }

    &__select-country {
      margin-bottom: 16px;

      .Select__indicators {
        display: none;
      }

      &::after {
        display: none;
      }
    }

    &__select-nationality {
      margin-bottom: 16px;

      .Select__indicators {
        display: none;
      }

      &::after {
        display: none;
      }
    }

    &__select-client-type {
      margin-bottom: 15px;
    }

    .Agreements {
      margin-bottom: 8px;
    }
  }

  .RegForm__agreement-field {
    margin: 10px 0;
    text-align: left;

    > div {
      display: flex;
      align-items: center;
      cursor: pointer;
      user-select: none;
      font-size: 14px;
      line-height: 20px;
      color: #333;
    }
  }

  .RegForm__checkbox-visual {
    display: flex !important;
    align-items: center;
    justify-content: center;
    width: 20px !important;
    height: 20px !important;
    min-width: 20px;
    flex-shrink: 0;
    border: 1px solid #999;
    border-radius: 3px;
    margin-right: 8px;
    transition: all 0.15s ease;
  }

  .RegForm__agreement-field input:checked ~ div .RegForm__checkbox-visual,
  .RegForm__checkbox-visual.checked {
    background-color: #4500e2;
    border-color: #4500e2;
  }

  .RegForm__checkbox-text {
    display: flex !important;
    align-items: center;
    flex-wrap: wrap;
    text-align: left;

    a {
      color: #4500e2;
      text-decoration: underline;
      font-weight: 500;

      &:hover {
        color: #6a3ae8;
      }
    }
  }

  .RegistrationForm__inputs-inner {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    :global(.BaseTextField) {
      width: 48%;
      @include respond-to(sm) {
        width: 100%;
      }
    }

    label[for='password'] {
      top: 26px;
    }
  }

  .PartnerCode__inner {
    margin-bottom: 30px;
    text-align: left;
    button {
      font-size: 14px;
      position: relative;
      padding-bottom: 2px;
      &:hover {
        &:after {
          transform: scale(0);
        }
      }
      &:active {
        transform: translateY(2px);
      }
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        height: 1px;
        width: 100%;
        transition: all 0.4s ease;
        opacity: 0.3;
      }
    }
  }
  .RegistrationForm__agreement-checkbox {
    margin: 0 0 16px 0;
    text-align: left;
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 0 0 8px 0;

    input[type='checkbox'] {
      display: none;
    }

    .agreement-label {
      display: flex !important;
      align-items: center;
      cursor: pointer;
      user-select: none;
      font-size: 13px;
      line-height: 18px;
      color: #333;
      position: relative;
    }

    .agreement-check-box {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      min-width: 20px;
      flex-shrink: 0;
      border: 1px solid #999;
      border-radius: 3px;
      margin-right: 8px;
      margin-top: 1px;
      transition: all 0.2s ease;

      svg {
        width: 14px;
        height: 11px;
        fill: none;
        stroke: #ffffff;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-dasharray: 16px;
        stroke-dashoffset: 16px;
        transition: all 0.3s ease;
        transition-delay: 0.1s;
      }
    }

    input[type='checkbox']:checked ~ .agreement-label .agreement-check-box {
      background: #4500e2;
      border-color: #4500e2;

      svg {
        stroke-dashoffset: 0;
      }
    }

    .agreement-check-box:hover {
      border-color: #4500e2;
    }

    .agreement-check-text {
      display: inline;
      text-align: left;

      a {
        color: #4500e2;
        text-decoration: underline;
        font-weight: 500;

        &:hover {
          color: #6a3ae8;
        }
      }
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css`
    .PartnerCode__inner {
      button {
        color: ${colors.secondary.hex};
        &:hover {
          color: ${colors.primary.hex};
          &:after {
            background-color: ${colors.primary.hex};
          }
        }
        &:after {
          background: ${colors.secondary.hex};
        }
      }
    }

    .RegistrationForm__agreement-checkbox {
      .agreement-check-box {
        border: 1px solid ${colors.lightGray.hex};
      }

      .agreement-check-box:hover {
        border-color: ${colors.primary.hex};
      }

      input[type='checkbox']:checked ~ .agreement-label .agreement-check-box {
        background: ${colors.primary.hex};
        border-color: ${colors.primary.hex};
      }

      .agreement-check-text {
        a {
          color: ${colors.primary.hex};

          &:hover {
            color: ${colors.primary.hex};
            opacity: 0.8;
          }
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
